import { getCompleteSizes, TAdFoxBannerSizeProps } from '@cian/adfox-component';
import { makeContextModule, NoSsr } from '@cian/react-utils';
import * as React from 'react';

import { useAdfoxParams } from './internal/hooks/useAdfoxParams';
import { TPParams } from '../../../types';

import type { TAdfoxContextData } from './types';

const contextData = makeContextModule<TAdfoxContextData>({ contextName: 'AdfoxContextData' });

const {
  Context: { Provider },
} = contextData;

export const { useContext: useAdfoxContext, withContext: withAdfoxContext, Context: AdfoxContext } = contextData;

export type TAdfoxContextProviderProps = Omit<TAdfoxContextData, 'params' | 'sizes'> & {
  children: React.JSX.Element;
  pParams: TPParams;
  size: TAdFoxBannerSizeProps;
};

const AdfoxContextProviderComponent: React.FC<TAdfoxContextProviderProps> = props => {
  const { children, pParams, size, postViewAnalyticsData, bannerPlace } = props;

  const params = useAdfoxParams(pParams);

  const contextValue = React.useMemo((): TAdfoxContextData => {
    return {
      bannerPlace,
      params,
      postViewAnalyticsData,
      sizes: getCompleteSizes(size),
    };
  }, [bannerPlace, params, postViewAnalyticsData, size]);

  return <Provider value={contextValue}>{children}</Provider>;
};

export const AdfoxContextProvider: React.FC<TAdfoxContextProviderProps> = props => (
  <NoSsr>
    <AdfoxContextProviderComponent {...props} />
  </NoSsr>
);
